const PromoCancelReasonEnum = {
  INCORRECT: "incorrect",
  DUPLICATE: "duplicate",
  OTHERS: "others",
};

export default PromoCancelReasonEnum;
